<template>
    <v-container width="100%">
        <v-data-table
            v-if="asks?asks.total>0:false"
            :items="asks.requests"
            :headers="headers_ask"
            :options.sync="options"
            :server-items-length="asks.total"
            style="width: 100%"
            dense
        >
        <template v-slot:item.req_time="{value}">
            {{ t(value) }}
        </template>
        <template v-slot:item.complete_time="{value, item}">
            <v-btn v-if="value == null" small icon @click="complete(item)">
                <v-icon>mdi-check</v-icon>
            </v-btn>
            <div v-else>
                {{ t(value) }}
            </div>
        </template>
        <template v-slot:item.start_time="{item}">
            {{ item.start_time }}
        </template>
        <template v-slot:item.end_time="{item}">
            {{ e(item) }}
        </template>
        </v-data-table>
        <v-dialog
            v-model="dialog"
            max-width="400px"
        >
            <v-card title>
                <v-card-title>Confirm</v-card-title>
                <v-card-text>
                    <v-row class="ma-1">
                    Change expired from&ensp;
                    <span :class="{from_modi:d_data.expired != pick}" class="from">
                    <v-edit-dialog>
                        {{ pick }}
                    <template v-slot:input>
                        <v-date-picker
                            v-model="pick"
                            :allowed-dates="date_valid"
                        >
                        </v-date-picker>
                    </template>
                    </v-edit-dialog>
                    </span>
                    &ensp;to&ensp; <span class="to">
                    <v-edit-dialog>
                        {{ expired }}
                    <template v-slot:input>
                        <v-date-picker
                            v-model="pick_end"
                            :allowed-dates="date_valid_expired"
                        >
                        </v-date-picker>
                    </template>
                    </v-edit-dialog></span></v-row>
                </v-card-text>
                <v-card-actions flat dark>
                    <v-btn @click="complete_ok">
                        Confirm
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import gql from 'graphql-tag'
import moment from 'moment'
import Swal from 'sweetalert2'
export default {
    name: 'ContractResolver',
    props: ['global'],
    data() {
        return {
            headers_ask: [
                {
                    text: 'Ask time',
                    value: 'req_time'
                },
                {
                    text: 'Client name',
                    value: 'contract_name'
                },
                {
                    text: 'Ask service',
                    value: 'service_name'
                },
                {
                    text: 'Ask amount',
                    value: 'amount'
                },
                {
                    text: 'Complete',
                    value: 'complete_time'
                },
                {
                    text: "Start time",
                    value: "start_time"
                },
                {
                    text: "End time",
                    value: "end_time"
                }
            ],
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            dialog: false,
            d_data: {},
            pick: '',
            pick_end: '',
        }
    },
    computed: {
        expired() {
            return moment(this.pick_end).format('YYYY-MM-DD')
        }
    },
    methods: {
        e(d) {
            if (d.start_time == null) return null;
            return moment(d.start_time).add(d.amount-1, 'days').format('YYYY-MM-DD')
        },        
        date_valid_expired(e) {
            return moment(e).diff(moment(this.d_data.expired).add(this.d_data.amount-1, 'days')) >= 0
        },
        date_valid(e) {
            return moment(e).diff(moment(this.d_data.expired)) >= 0
        },
        complete_ok() {
            this.$apollo.mutate({
                mutation: gql`mutation CompleteRequest($completeRequestId: Int!, $from: String!) {
                    completeRequest(id: $completeRequestId, from: $from)
                    }`,
                variables: {
                    completeRequestId: this.d_data.id,
                    from: this.pick
                }
            })
            .then((v) => {
                Swal.fire({
                    icon: "success",
                    title: "Sucess to complete",
                    showConfirmButton: false,
                    toast: true,
                    timer: 1000
                });
                this.d_data.item.complete_time = v.data.completeRequest
                this.d_data.item.start_time = this.pick
                this.dialog = false
            }).catch((e) => {
                Swal.fire({
                    icon: 'error',
                    text: e.message,
                })
            });

        },
        complete(e) {
            this.$apollo.query({
                query: gql`query Contract($phone: String!) {
                    contract(phone: $phone) {
                        expired(fix: true)
                    }
                }`,
                variables: {
                    phone: e.contract_name
                },
                fetchPolicy: 'no-cache'
            }).then((v) => {
                console.log(v.data.contract.expired)
                this.d_data = {}
                this.pick = this.d_data.expired = moment(v.data.contract.expired).add(1, 'days').format('YYYY-MM-DD')
                this.pick_end = moment(this.pick).add(e.amount-1, 'days').format('YYYY-MM-DD')
                this.d_data.amount = e.amount
                this.d_data.id = e.id
                this.d_data.item = e
                this.dialog = true
            }).catch((e) => {
                Swal.fire({
                    icon: 'error',
                    text: e.message,
                })
            })
        },
        t(date) {
            return moment(parseInt(date)).local().format('YYYY-MM-DD HH:mm:ss');
        },
    },
    watch: {
        'global.refresh': function() {
            if (this.global.refresh > 0)
                this.$apollo.queries.asks.startPolling(this.global.refresh)
            else
                this.$apollo.queries.asks.stopPolling(this.global.refresh)
        },
        pick_end() {
            this.pick = moment(this.pick_end).add(-(this.d_data.amount-1), 'days').format('YYYY-MM-DD')
        },
        pick() {
            this.pick_end = moment(this.pick).add((this.d_data.amount-1), 'days').format('YYYY-MM-DD')
        }
    },
    apollo: {
        asks: {
            query: gql`query req ($offset: Int, $limit: Int) {
                asks(offset: $offset, limit: $limit) {
                    total
                    requests {
                        id
                        contract_name
                        req_time
                        service_name
                        amount
                        complete_time
                        start_time
                    }
            }}`,
            variables: function() { return {
                limit: this.options.itemsPerPage,
                offset: (this.options.page-1) * this.options.itemsPerPage
            }},
            fetchPolicy: 'no-cache',
        },
    }
}
</script>
<style scoped>
.from {
    font-weight: 1000;
}
.from_modi {
    color: red;
}
.to {
    font-weight: 1000;
}
</style>